import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Card, Button } from "../ui";
import { eventHref, isTonight, nextEventSubtitle } from "../../lib/publicListingFormat";

/**
 * Quiet next-event peak for host + school public profiles.
 * Soft meta, theme-aware RSVP — Lu.ma listing rhythm.
 */
export default function NextEventFlyer({
  event,
  testIdPrefix,
  titleFn = null,
  linkState = undefined,
}) {
  const nav = useNavigate();
  if (!event) return null;
  const tonight = isTonight(event);
  const title = titleFn ? titleFn(event) : event.name;
  const href = eventHref(event);

  function openEvent(e) {
    if (e.target.closest("a,button")) return;
    nav(href, linkState ? { state: linkState } : undefined);
  }

  return (
    <Card
      interactive
      className="p-5 space-y-4 cursor-pointer"
      data-testid={`${testIdPrefix}-next-event`}
      onClick={openEvent}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          openEvent(e);
        }
      }}
      role="link"
      tabIndex={0}
    >
      <div className="space-y-1">
        <p
          className={
            tonight
              ? "font-ui font-medium text-[12px] tracking-wide text-ink"
              : "font-ui font-medium text-[12px] tracking-wide text-ink-secondary"
          }
        >
          {tonight ? "Tonight" : "Next event"}
        </p>
        <h2 className="font-ui font-semibold text-[20px] leading-snug text-ink text-balance">
          {title}
        </h2>
        <p className="font-ui text-[13px] font-medium text-ink-secondary">{nextEventSubtitle(event)}</p>
      </div>
      <Button
        as={Link}
        to={href}
        state={linkState}
        variant="primary"
        size="md"
        className="w-full sm:w-auto"
        data-testid={`${testIdPrefix}-next-event-rsvp`}
        aria-label={tonight ? `RSVP for tonight: ${title}` : `RSVP: ${title}`}
        onClick={(e) => e.stopPropagation()}
      >
        {tonight ? "RSVP for tonight →" : "RSVP →"}
      </Button>
    </Card>
  );
}
